<script lang="ts">
    import dayjs from "dayjs";
    export let value;
</script>
<span>{dayjs(value.value||value).format('DD.MM.YYYY')}</span>